export const isBlank = (...values) => {
return values
  .map(value => typeof(value) === 'undefined' || (typeof(value) !== 'undefined' && value.trim() === '')
  )
  .every((value) => value)
}
